/**
 * Хуки данных «Шаблоны смен» (manager design v3 §8.2).
 * Бэк: GET/POST/PUT/DELETE /v1/scheduling/shift-templates.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  createShiftTemplate,
  deleteShiftTemplate,
  listShiftTemplates,
  updateShiftTemplate,
} from '@hsc/api-client';
import type { ShiftTemplate, ShiftTemplateInput } from '@hsc/types';

export const SHIFT_TEMPLATES_KEY = ['scheduling', 'shift-templates'] as const;

export function useShiftTemplates(includeInactive = false) {
  return useQuery<ShiftTemplate[]>({
    queryKey: [...SHIFT_TEMPLATES_KEY, includeInactive] as const,
    queryFn: async () => (await listShiftTemplates(includeInactive)).items,
    staleTime: 30_000,
  });
}

export function useCreateShiftTemplate() {
  const qc = useQueryClient();
  return useMutation<ShiftTemplate, Error, ShiftTemplateInput>({
    mutationFn: createShiftTemplate,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: SHIFT_TEMPLATES_KEY });
    },
  });
}

export function useUpdateShiftTemplate() {
  const qc = useQueryClient();
  return useMutation<ShiftTemplate, Error, { id: string; input: ShiftTemplateInput }>({
    mutationFn: ({ id, input }) => updateShiftTemplate(id, input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: SHIFT_TEMPLATES_KEY });
    },
  });
}

export function useDeleteShiftTemplate() {
  const qc = useQueryClient();
  return useMutation<void, Error, string>({
    mutationFn: deleteShiftTemplate,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: SHIFT_TEMPLATES_KEY });
    },
  });
}
